import { Box } from "@chakra-ui/react";
import { useConfigurationMenu } from "@raiden/library/hooks/useConfigurationMenu";
import { Fragment } from "react";
import { MenuItem } from "./MenuItem";
import { SubMenuItem } from "./SubMenuItem";

/**
 * @typedef {Object} Props
 * @property {() => void} onClickSearch
 * @property {() => void} onClickMenu
 */
/**
 * @param {Props} props
 */
export function MenuMobile({ onClickSearch, onClickMenu }) {
  const { menu } = useConfigurationMenu({ alias: "header" });
  const { menu: subMenu } = useConfigurationMenu({ alias: "header-top-bar" });

  return (
    <Box>
      {menu && menu.items.length > 0 && (
        <>
          {menu.items.map((item, index) => (
            <MenuItem
              menuItem={item}
              onClickSearch={onClickSearch}
              onClickMenu={onClickMenu}
              key={index}
            />
          ))}
        </>
      )}

      {subMenu && subMenu.items.length > 0 && (
        <>
          {subMenu.items.map((menuItem, index) => (
            <Fragment key={index}>
              <SubMenuItem menuItem={menuItem} key={index} />
            </Fragment>
          ))}
        </>
      )}
    </Box>
  );
}
